<template>
<el-dialog
    width="600px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
  <div class="title">导入员工</div>
 <el-form ref="form" :model="form" label-width="100px"  label-position="left" :rules="rules">
  <el-form-item label="导入方式：" prop="fileType" >
    <el-radio-group v-model="form.fileType">
      <el-radio label="0">税局导入</el-radio>
      <el-radio label="1">模版导入</el-radio>
    </el-radio-group>
    <div class="taxTip" v-if="form.fileType==0">
      在个税扣缴的电子税务局客户端首页进入<span style="color:#FF6010">人员信息采集界面</span>，
      选择<span style="color:#FF6010">“导出”—“导出全部”</span>，选择导出<span style="color:#FF6010">“办税大厅采集表”</span>。
    </div>
    <!-- <el-select v-model="form.type" placeholder="请选择" size="small">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select> -->
  </el-form-item>
  <el-form-item label="文件上传：" >
    <el-upload
      class="upload-demo"
      action=""
      :auto-upload="false"
      drag
      accept=".xls,.xlsx"
      :on-change="handleChange"
      :file-list="files">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>   
    <el-button type="text" @click="downlodaTemplate" v-if="form.fileType==1">模板下载</el-button>
  </el-form-item>
 </el-form>
  <div class="footer acc_flex">
      <el-button size="small" @click="visible = false" :disabled="isRequest">取消</el-button>
      <el-button size="small" class="submit" @click="submit" :disabled="isRequest">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {importEmployee} from '@/api/index.js'
export default {
  data() {
    return {
      rules:{
        fileType:[{ required: true, message: '请选择导入方式', trigger: 'blur' }],
      },
      yearPeriod:'',
      files:[],
      form:{
        fileType:"0",
      },
      visible:false,
      isRequest:false,
    };
  },
  methods:{
    handleChange(file,fileList){
      this.files = [] 
      this.files.push(file)
      let testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension = testmsg === 'xls'
	  const extension2 = testmsg === 'xlsx'
      if(!extension && !extension2) {
        this.$message({
					message: '上传文件只能是 xls、xlsx格式!',
					type: 'error'
				});
        this.files = []
				return false
			}
    },
    submit(){
      this.$refs.form.validate((valid) => {
        if(valid){
          if(!this.files.length){
            this.$message.error('请上传文件')
            return
          }
          let formData = new FormData()
           formData.append('file',this.files[0].raw)
           formData.append('cid',sessionStorage.getItem('cid'));
           formData.append('token',sessionStorage.getItem('token'));
           formData.append('fileType',this.form.fileType)
           this.isRequest = true
           importEmployee(formData).then(res=>{
              if(res.data.code==1) {
                 this.$message.success(res.data.msg)
                 
                 this.visible = false
                  this.$emit('refsh')
              }
           }).finally(()=>{
            this.isRequest = false
           })
        }
      })
    },
    downlodaTemplate(){
      let cid=sessionStorage.getItem('cid');
	  let token=sessionStorage.getItem('token');
	  window.location.href = `${this.$rootUrl}employee/exportEmployee?cid=${cid}&token=${token}&templateName=员工导入模板.xlsx&isImport=1`;
    },
    openTask(yearPeriod){
      this.yearPeriod = yearPeriod||''
      this.files = []
      this.form.fileType = '0'
      this.visible = true
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
    },
  }
};
</script>

<style lang="less" scoped>
.taxTip {
  width: 360px;
  padding: 10px 24px 10px 10px;
  box-sizing: border-box;
  background: #FBFBFB;
  font-size: 12px;
  margin-top: 6px;
  color: #999999;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/StaffExcell.vue